import { Protocol } from "./Protocol";
import { Objects } from "./object";

export class getObjectById {
    _id:number;
    name: string;
    displayName:string
    Protocol:Protocol[]
    }